import { ChangeDetectionStrategy, Component, computed, Input, input, signal } from '@angular/core';
import { FaqSectionComponent } from 'src/app/faq/components/faq-section/faq-section.component';

import { FaqCategory, FaqItem } from 'src/app/faq/models';
import { ContentBlock } from '../../models';
import { CookiePreferences } from '@teamfoster/sdk/cookie-ngrx';

@Component({
  selector: 'app-content-block-faq',
  imports: [FaqSectionComponent],
  templateUrl: './content-block-faq.component.html',
  styleUrl: './content-block-faq.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentBlockFaqComponent {
  block = input<ContentBlock>();
  cookies = input<CookiePreferences | undefined>();
  // faq$ = signal(groupFaqs(exampleFaqs));
  // faqSectionTitle = Object.keys(this.faq$())[0];
  // faqSection$ = computed(() => {
  //   return this.faq$()[this.faqSectionTitle];
  // });

  faq$ = computed(() => {
    return this.block()?.faq?.reduce((acc: { [key: string]: { [key: string]: FaqItem[] } }, cur) => {
      const catName = cur.category.name;
      // acc[catName].push(cur);
      return acc;
    }, {});
  });

  faqArray$ = computed(() => {
    return (this.block()?.faq || []).reduce((acc: { [key: string]: FaqItem[] }, cur) => {
      const catName = cur.category.name;

      if (!acc[catName]) {
        acc[catName] = [];
      }
      acc[catName].push(cur);

      return acc;
    }, {});
  });

  faqSectionTitle = computed(() => {
    return Object.keys(this.faq$() ?? {})[0];
  });

  faqSection$ = computed(() => {
    const faq = this.faq$();
    const faqSectionTitle = this.faqSectionTitle();
    return faq && faqSectionTitle ? (faq[faqSectionTitle] ?? {}) : {};
  });
}
